import React from "react";
import { useTranslation } from "react-i18next";
import questionIcon from "assets/ui-img/questionMarkWhiteCircleBg.png";
import { SelectServiceMenu, Header, TitleBar, PaginationHelper, FooterNavigation } from "webapp/components";
import "./SelectService.scss";
import SelectService from "webapp/components/SelectServiceMenu/SelectService";
import { AppState } from "webapp/enums/AppState";
import { useState } from "react";

/**
 *
 * @param {
 * context - the `this` of the outer class component WebAppView
 * currState - imports the current form information into the view if it exists
 * callBackFunc - imports the callback function which will update the main state
 *  with a new service
 * backButtonFunc - imports the functionality to regress the webapp by one state
 *  to the confirm vehicle in this case
 * } props
 * @returns
 */
export default function ConfirmServices(props) {
  const { t } = useTranslation();
  const [serviceObj, setServiceObj] = useState(props.currState.Service);

  const ConfirmCustomerObj = {
    img: props.currState.partner === "PBFL" ? props.currState.localGroupLogo : questionIcon,
    partner: props.currState.partner,
    fragment: (
      <React.Fragment>
        <p>{t("description.ConfirmServicesTitleBar1")}</p>
      </React.Fragment>
    ),
  };

  /**
   *
   * @param {*} data
   * @returns boolean
   * @memberof ConfirmService
   */
  const checkIfAutoAccept = (data) => {
    if (data.serviceType.toUpperCase() !== "TOW") {
      return true;
    } else {
      return false;
    }
  };

  const onUserNext = (data) => {
    setServiceObj(data);

    const context = props.context;
    context.setState(
      {
        Service: data.serviceType,
        isAutoAccept: checkIfAutoAccept(data),
        FuelType: data.fuelType,
        towReason: data.towReason,
        // riderCount: data.riderCount ? data.riderCount : 0,
        // winchCircumstance: data.winchCircumstance ? data.winchCircumstance : "",
        // winchDistance: data.winchDistance ? data.winchDistance : "",
        // ifTiresIntactRoll: data.ifTiresIntactRoll ? data.ifTiresIntactRoll : "",
        // locksmithType: data.locksmithType ? data.locksmithType : "",
        additionalDetails: data.additionalDetails,
        scheduledEventDate: data.scheduledEventDate,
        DestinationAddress: "",
        DestinationCompany: "",
        DestinationStreet: "",
        DestinationCity: "",
        DestinationZip: "",
        DestinationCountry: "",
        DestinationCoords: {
          lat: null,
          lng: null,
        },
      },
      () => {
        context.setState(
          {
            webAppState: context.state.navigationService.getState(AppState.SelectService).getNextState(context.state),
          },
          () => {
            // after user selects their service:
            /*apiSetSubmitStage(
              this.state,
              4,
              this.state.Service || "Service Type Not Available"
            );*/
            if (typeof props.onUserNext === "function") {
              props.onUserNext(data);
            }
          },
        );
      },
    );
    /*if (typeof props.onUserNext === "function") {
      props.onUserNext(data);
    }*/
  };

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  return (
    <div className="ServiceFragment">
      <Header
        currState={props.currState}
        onUserBack={onUserBack}
        information={t("description.ConfirmServicesHeader1")}
      />
      <TitleBar data={ConfirmCustomerObj} />
      <PaginationHelper context={props.context} />
      <SelectService
        context={props.context}
        currState={props.currState}
        locale={props.currState.DisablementCountry || props.currState.locale}
        localGroup={props.localGroup}
        serviceObj={serviceObj}
        onUserNext={onUserNext}
        onUserCancel={onUserCancel}
      />
      {/* <SelectServiceMenu locale={props.currState.DisablementCountry} localGroup={props.localGroup} serviceObj={serviceObj} callBackFunc={selectServiceCallBack} cancelCallback={onUserCancel} /> */}
    </div>
  );
}
